import type {
  Pixel,
  PixelPlatform,
  EventMapping,
  CredentialPayload,
} from '@/data'
import api from '..'

export interface PixelPayload {
  name: string
  platform: PixelPlatform
  pixel_id: string
  partner_id: number
  credential: CredentialPayload
  pixel_events: EventMapping[]
}

export async function createPixel(payload: PixelPayload): Promise<Pixel> {
  const res = await api.post('/pixels', payload)
  return res.data.data
}
